import { OptionItem } from "@transfr-inc/dashboard-components/forms";

export class OrgOptionItem extends OptionItem {
  constructor(org) {
    const { code, name } = org;
    super({ id: code, text: name, data: org });
  }
}
